module.exports = __webpack_public_path__ + "media/images/header_logo-8a3aee76b5450cb708ed3df5124e0c3d.svg";